// extracted by mini-css-extract-plugin
module.exports = {"chat-sticker-message":"chat-sticker-message_chat-sticker-message__3H-4E","chat-sticker-message__logo":"chat-sticker-message_chat-sticker-message__logo__16BSE"};